import { useTranslations } from 'next-intl'
import { z } from 'zod'

export const createZPassportVerificationForm = (
  t: ReturnType<typeof useTranslations<'passport_verification'>>,
) =>
  z.object({
    contactNumber: z.string().min(5, t('phone_number_error_min_length')),
    passportImageUrl: z.string().min(1, t('passport_photo_error_required')),
  })

export type TPassportVerificationForm = z.infer<
  ReturnType<typeof createZPassportVerificationForm>
>

export const passportVerificationFormDefaultValues = {
  contactNumber: '',
  passportImageUrl: '',
}
